module.exports = __webpack_public_path__ + "img/arrow-up-right.cc3e8f2d.svg";